import { render, staticRenderFns } from "./ViewLabourerAttendancePage.vue?vue&type=template&id=d0cca966&"
import script from "./ViewLabourerAttendancePage.vue?vue&type=script&lang=js&"
export * from "./ViewLabourerAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports